import { render, staticRenderFns } from "./StorePurchaseHistory.vue?vue&type=template&id=556b57d0&scoped=true"
import script from "./StorePurchaseHistory.vue?vue&type=script&lang=js"
export * from "./StorePurchaseHistory.vue?vue&type=script&lang=js"
import style0 from "./StorePurchaseHistory.vue?vue&type=style&index=0&id=556b57d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556b57d0",
  null
  
)

export default component.exports